import React, {useState} from "react";
import {useTranslation} from "react-i18next";

import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import SupportRequestActions from "./components/actions";
import SupportRequestForm from "./components/form";
import {COLORS} from "../../../../../config/constants";

import './support-new-request.scss'

const SUPPORT_REQUEST_FORM_ID = 'support-request-form';

type Props = {
  onCancel(): void;
}

const SupportNewRequest = ({onCancel}: Props) => {

  const [ isHelpCenterChecked, setIsHelpCenterChecked ] = useState(false);
  const { t } = useTranslation();

  return (
    <section className='support-new-request'>
      <Card className='support-new-request__card'>
        <FormControlLabel
          control={(
            <Checkbox
              checked={isHelpCenterChecked}
              onChange={(event) => setIsHelpCenterChecked(event.target.checked)}
            />
          )}
          label={(
            <Typography variant='body1' sx={{color: COLORS.BLACK_DARK, letterSpacing: 0, lineHeight: '28px'}}>
              {t('support__text__confirmationStart')}
              {' '}
              <Link
                href='https://help.vedmarket.ru/'
                rel='noreferrer'
                target='_blank'
                underline='always'
                sx={{color: COLORS.BLUE, cursor: 'pointer'}}
              >
                {t('support__text__helpCenterPrepositional')}
              </Link>
            </Typography>
          )}
        />
        {isHelpCenterChecked && <SupportRequestForm formId={SUPPORT_REQUEST_FORM_ID} />}
      </Card>
      {isHelpCenterChecked && (
        <SupportRequestActions
          formId={SUPPORT_REQUEST_FORM_ID}
          onCancel={onCancel}
        />
      )}
    </section>
  );
};

export default SupportNewRequest;
